import { useQuery } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { QUERY_KEYS } from "./querykeys";
import {
  AxiosResponseAndError,
  ResponseType,
} from "../types/axiosResponseType";
import ApiRequest from "../ApiRequest";


type PaymentStatusResponse = ResponseType<{
  id:string,
  status:string,
}>;


function usePaymentStatusQuery(id:string) {
  return useQuery<
    AxiosResponseAndError<PaymentStatusResponse>["response"],
    AxiosResponseAndError<PaymentStatusResponse>["error"]
  >({
    queryKey: [QUERY_KEYS.paymentStatus],
    queryFn: async () =>
      await ApiRequest.get(`${requestURLs.paymentStatus}${id}`),
    enabled: false,
  });
}

export default usePaymentStatusQuery;
